var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "loading-screen" }, [
          _c("div", { staticClass: "loading-spinner" }),
        ])
      : _c("div", [
          _vm.isActive()
            ? _c(
                "div",
                { staticClass: "business-profile" },
                [
                  _c("a-alert", {
                    attrs: {
                      message: "Someting is Wrong",
                      description:
                        "Any account details not taken, Please check your account information!",
                      type: "error",
                      "show-icon": "",
                    },
                  }),
                ],
                1
              )
            : _c("div", { staticClass: "business-profile" }, [
                _c("div", { staticClass: "business-profile-details" }, [
                  _c("div", { staticClass: "profile-image-detail" }, [
                    _c("div", { staticClass: "profile-image" }, [
                      _c("img", {
                        attrs: { src: _vm.profile.profilePicture, alt: "" },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-image-description" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("whatsapp_business_api.profileImageDesc")
                          ) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "business-description" }, [
                    _c("div", { staticClass: "business-description-title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.bussinesDesciption")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "business-description-info" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("whatsapp_business_api.descOfWork")) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "business-description-input" },
                      [
                        _c("a-textarea", {
                          attrs: { "auto-size": { minRows: 5, maxRows: 5 } },
                          model: {
                            value: _vm.profile.profile.desc,
                            callback: function ($$v) {
                              _vm.$set(_vm.profile.profile, "desc", $$v)
                            },
                            expression: "profile.profile.desc",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "business-website-input" },
                    [
                      _c(
                        "div",
                        { staticClass: "business-website-input-title" },
                        [_vm._v("Business Website 1")]
                      ),
                      _vm._v(" "),
                      _c("a-input", {
                        attrs: { "auto-size": { minRows: 5, maxRows: 5 } },
                        model: {
                          value: _vm.profile.profile.website1,
                          callback: function ($$v) {
                            _vm.$set(_vm.profile.profile, "website1", $$v)
                          },
                          expression: "profile.profile.website1",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "business-website-input" },
                    [
                      _c(
                        "div",
                        { staticClass: "business-website-input-title" },
                        [_vm._v("Business Website 2")]
                      ),
                      _vm._v(" "),
                      _c("a-input", {
                        attrs: { "auto-size": { minRows: 5, maxRows: 5 } },
                        model: {
                          value: _vm.profile.profile.website2,
                          callback: function ($$v) {
                            _vm.$set(_vm.profile.profile, "website2", $$v)
                          },
                          expression: "profile.profile.website2",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "business-email-input" },
                    [
                      _c("div", { staticClass: "business-email-input-title" }, [
                        _vm._v(_vm._s(_vm.$t("calendar.emailAddress"))),
                      ]),
                      _vm._v(" "),
                      _c("a-input", {
                        attrs: { "auto-size": { minRows: 5, maxRows: 5 } },
                        model: {
                          value: _vm.profile.profile.profileEmail,
                          callback: function ($$v) {
                            _vm.$set(_vm.profile.profile, "profileEmail", $$v)
                          },
                          expression: "profile.profile.profileEmail",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "business-about-input" },
                    [
                      _c("div", { staticClass: "business-about-input-title" }, [
                        _vm._v(_vm._s(_vm.$t("calendar.about")) + " *"),
                      ]),
                      _vm._v(" "),
                      _c("a-textarea", {
                        attrs: { "auto-size": { minRows: 5, maxRows: 5 } },
                        model: {
                          value: _vm.profile.about,
                          callback: function ($$v) {
                            _vm.$set(_vm.profile, "about", $$v)
                          },
                          expression: "profile.about",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "business-profile-information" }, [
                  _c(
                    "div",
                    { staticClass: "business-profile-information-status" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "business-profile-information-status-title",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("whatsapp_business_api.wabaOverview"))
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "business-profile-information-status-details",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "business-profile-information-status-details-card",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "business-profile-information-status-details-card-status",
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "business-profile-information-status-details-card-status-badge",
                                    attrs: {
                                      status:
                                        _vm.accountStatus[
                                          _vm.profile.wabaInfo.accountStatus
                                        ].color,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "business-profile-information-status-details-card-status-name",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.accountStatus[
                                              _vm.profile.wabaInfo.accountStatus
                                            ].text
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "business-profile-information-status-details-card-title",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "whatsapp_business_api.accountStatus"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "business-profile-information-status-details-card",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "business-profile-information-status-details-card-status",
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "business-profile-information-status-details-card-status-badge",
                                    attrs: {
                                      status:
                                        _vm.dockerStatus[
                                          _vm.profile.wabaInfo.dockerStatus
                                        ].color,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "business-profile-information-status-details-card-status-name",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.dockerStatus[
                                              _vm.profile.wabaInfo.dockerStatus
                                            ].text
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "business-profile-information-status-details-card-title",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "whatsapp_business_api.dockerStatus"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "business-profile-information-status-details-card",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "business-profile-information-status-details-card-status",
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "business-profile-information-status-details-card-status-badge",
                                    attrs: {
                                      status:
                                        _vm.phoneQuality[
                                          _vm.profile.wabaInfo.phoneQuality
                                        ].color,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "business-profile-information-status-details-card-status-name",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.phoneQuality[
                                              _vm.profile.wabaInfo.phoneQuality
                                            ].text
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "business-profile-information-status-details-card-title",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "whatsapp_business_api.phoneQuality"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "business-profile-information-status-details-card",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "business-profile-information-status-details-card-status",
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "business-profile-information-status-details-card-status-badge",
                                    attrs: { status: "SUCCESS" },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "business-profile-information-status-details-card-status-name",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            (
                                              _vm.profile.wabaInfo
                                                .messagingLimit || ""
                                            ).split("_")[1]
                                          ) +
                                          "\n                                    "
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "whatsapp_business_api.customersOrDay"
                                              )
                                            )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "business-profile-information-status-details-card-title",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "whatsapp_business_api.messagingLimit"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "business-profile-information-status-details-card",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "business-profile-information-status-details-card-status",
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "business-profile-information-status-details-card-status-badge",
                                    attrs: {
                                      status:
                                        _vm.canSendMessage[
                                          _vm.profile.wabaInfo.canSendMessage
                                        ].color,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "business-profile-information-status-details-card-status-name",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.canSendMessage[
                                              _vm.profile.wabaInfo
                                                .canSendMessage
                                            ].text
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "business-profile-information-status-details-card-title",
                                },
                                [
                                  _vm._v(
                                    "\n                                 " +
                                      _vm._s(
                                        _vm.$t(
                                          "whatsapp_business_api.canSendMessage"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "business-profile-information-address" },
                    [
                      _c("div", { staticClass: "official-details" }, [
                        _c("div", { staticClass: "official-details-title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("whatsapp_business_api.officialDetails")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "official-details-description" },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    "whatsapp_business_api.officialDetailsDesc"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "official-details-form" }, [
                          _c(
                            "div",
                            { staticClass: "official-details-form-item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-title",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "whatsapp_business_api.addressLine"
                                      )
                                    ) + " 1"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-input",
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      value: _vm.profile.profile.addLine1,
                                      "auto-size": { minRows: 5, maxRows: 5 },
                                      disabled: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "official-details-form-item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-title",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "whatsapp_business_api.addressLine"
                                      )
                                    ) + " 2"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-input",
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      value: _vm.profile.profile.addLine2,
                                      "auto-size": { minRows: 5, maxRows: 5 },
                                      disabled: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "official-details-form-item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-title",
                                },
                                [_vm._v(_vm._s(_vm.$t("message.city")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-input",
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      value: _vm.profile.profile.city,
                                      "auto-size": { minRows: 5, maxRows: 5 },
                                      disabled: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "official-details-form-item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-title",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "whatsapp_business_api.stateIfApplic"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-input",
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      value: _vm.profile.profile.state,
                                      "auto-size": { minRows: 5, maxRows: 5 },
                                      disabled: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "official-details-form-item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-title",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "whatsapp_business_api.zipCodeOrPostCode"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-input",
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      value: _vm.profile.profile.pinCode,
                                      "auto-size": { minRows: 5, maxRows: 5 },
                                      disabled: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "official-details-form-item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-title",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "whatsapp_business_api.selectCountry"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-input",
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      value: _vm.profile.profile.country,
                                      "auto-size": { minRows: 5, maxRows: 5 },
                                      disabled: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "official-details-form-item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-title",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "whatsapp_business_api.selectBussVertical"
                                      )
                                    ) + "*"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "official-details-form-item-input",
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        value: _vm.profile.profile.vertical,
                                        disabled: "",
                                      },
                                    },
                                    _vm._l(_vm.verticals, function (vertical) {
                                      return _c(
                                        "a-select-option",
                                        {
                                          key: vertical,
                                          attrs: { value: vertical },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(vertical) +
                                              "\n                                        "
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "business-submit" },
                    [
                      _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "", disabled: _vm.isSaving },
                          on: { click: _vm.saveProfile },
                        },
                        [
                          !_vm.isSaving
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("whatsapp_business_api.saveInfo")
                                    )
                                ),
                              ]
                            : [
                                _c("div", {
                                  staticClass: "button-loading-spinner",
                                }),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }